import { useId } from 'react';

/**
 * Small inline 4-point sparkle marking AI-generated output — filled with the
 * brand→teal gradient (#a93a4c → #d98a2b → #2e6e6e). Decorative only
 * (`aria-hidden`). Each instance mints a unique gradient id via `useId` so
 * multiple sparks on one screen don't collide on the SVG `<defs>` reference.
 */
export function AiSpark({ className }: { className?: string }) {
  const gradientId = useId();
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      focusable="false"
      role="presentation"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#a93a4c" />
          <stop offset="50%" stopColor="#d98a2b" />
          <stop offset="100%" stopColor="#2e6e6e" />
        </linearGradient>
      </defs>
      <path
        d="M12 0.5c1 6.6 4.9 10.5 11.5 11.5C16.9 13 13 16.9 12 23.5 11 16.9 7.1 13 0.5 12 7.1 11 11 7.1 12 0.5Z"
        fill={`url(#${gradientId})`}
      />
    </svg>
  );
}
